(function () {
  'use strict';

  angular.module('utils.htmlPartialScriptLoader', [])
    .factory('htmlPartialScriptLoader', htmlPartialScriptLoader);

  htmlPartialScriptLoader.$inject = ['$q', 'scriptsForPartial'];

  function htmlPartialScriptLoader($q, scriptsForPartial) {
    return {
      response: response
    };

    function response(response) {
      var scriptForPartial = scriptsForPartial[response.config.url];

      if (scriptForPartial && !scriptForPartial.loaded) {

        var deferred = $q.defer();

        $.getScript(scriptForPartial.src, function (data, textStatus, jqxhr) {
          console.log('script loaded!', scriptForPartial.src);
          scriptForPartial.loaded = true;
          deferred.resolve(response);
        });

        // check window for script
        // if not there load it
        // then return the http call to load the controller
//          setTimeout(function() {
//            console.log('done');
//            deferred.resolve(response);
//          }, 1);

        return deferred.promise;
      } else {
        return response || $q.when(response);
      }
    }
  }

})();
